import { Injectable, OnInit, Injector } from '@angular/core';
import { SessionService } from 'app/resources/services/session-service.service';
import { HttpService } from 'app/resources/services/http.service';

@Injectable()
export class CssService {

  private processando = true;
  private parametro = undefined;
  private css: any;
  public cssCarregado: boolean;

  constructor(public sessionService: SessionService, public http: HttpService) {
    this.setParametro();
    this.SetCss();
  }

  private setParametro() {
    if (this.http.location.hostname === 'www.picpontos.com.br' ||
      this.http.location.hostname === 'picpontos.com.br' ||
       this.http.location.hostname === 'homolog.picpontos.com.br') {
      if (this.sessionService && this.sessionService.getClientUuid()) {
        this.parametro = '?type=client&content=' + this.sessionService.getClientUuid();
      } else {
        this.parametro = '?type=context&content=' + this.http.location.href.split('/')[3];
      }
    } else {
      if (this.sessionService && this.sessionService.getClientUuid()) {
        this.parametro = '?type=client&content=' + this.sessionService.getClientUuid();
      } else {
        this.parametro = '?type=domain&content=' + this.http.location.hostname;
      }
    }
  }

  private SetCss() {
    this.http.pathApi().get('clientes/style/' + this.parametro)
      .subscribe(
        sucesso => {
          this.css = sucesso.text();
          this.processando = false;
          this.cssCarregado = true;
        },
        erro => {
          this.processando = false;
          if (erro.status >= 400 && erro.status < 500) {
            this.cssCarregado = true;
          } else {
            this.cssCarregado = false;
          }
        }, () => {

        });
  }

  public get() {
    return this.css;
  }

  public disponivel(): boolean {
    this.setParametro();
    this.SetCss();
    return this.cssCarregado;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/css.service.ts